(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["astra-new-arrivals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-new-arrivals')) {
    customElements.define('astra-new-arrivals', class extends HTMLElement {
      connectedCallback() {
        this.checkExpiry = this.checkExpiry || (() => {
          clearTimeout(this.expiryTimer);
          const now = Date.now();
          let nextExpiry = Infinity;
          this.querySelectorAll('[data-arrival-expires]').forEach(card => {
            const expires = Number(card.dataset.arrivalExpires) * 1000;
            if (!Number.isFinite(expires) || expires <= now) card.remove();
            else nextExpiry = Math.min(nextExpiry, expires);
          });
          if (nextExpiry === Infinity) {
            (this.closest('.astra-arrivals-insert') || this).remove();
            return;
          }
          this.expiryTimer = setTimeout(this.checkExpiry, Math.min(nextExpiry - now, 2147483647));
        });
        window.addEventListener('pageshow', this.checkExpiry);
        document.addEventListener('visibilitychange', this.checkExpiry);
        this.checkExpiry();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        window.removeEventListener('pageshow', this.checkExpiry);
        document.removeEventListener('visibilitychange', this.checkExpiry);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["astra-newness-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-newness-badge')) {
    customElements.define('astra-newness-badge', class extends HTMLElement {
      connectedCallback() {
        this.checkExpiry = this.checkExpiry || (() => {
          clearTimeout(this.expiryTimer);
          const expires = Number(this.dataset.expires) * 1000;
          const remaining = expires - Date.now();
          if (!Number.isFinite(expires) || remaining <= 0) {
            this.remove();
            return;
          }
          this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
        });
        window.addEventListener('pageshow', this.checkExpiry);
        document.addEventListener('visibilitychange', this.checkExpiry);
        this.checkExpiry();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        window.removeEventListener('pageshow', this.checkExpiry);
        document.removeEventListener('visibilitychange', this.checkExpiry);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["astra-store-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-store-tools')) {
    customElements.define('astra-store-tools', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.started) return;
        this.started = true;
        this.events = new AbortController();
        this.count = Number(this.dataset.count) || 0;
        this.initialTitle = document.title;
        const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.events.signal });
        const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
        const write = (key, value) => { try { localStorage.setItem(key, String(value)); } catch {} };
        const key = 'astra-welcome-v1';
        const dialog = this.querySelector('dialog');
        this.dialog = dialog;
        let opener;
        const open = manual => {
          if (!dialog || dialog.open || document.visibilityState !== 'visible') return false;
          if (!manual && (document.querySelector('dialog[open],cart-drawer.active,.search-modal[open],.shopify-pc__banner__dialog') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || ''))) return false;
          opener = manual ? document.activeElement : null;
          dialog.showModal();
          (dialog.querySelector('[data-welcome-error],[data-welcome-success]') || dialog.querySelector('[data-welcome-close]'))?.focus({ preventScroll: true });
          return true;
        };
        if (dialog && typeof dialog.showModal === 'function') {
          const success = dialog.querySelector('[data-welcome-success]');
          const error = dialog.querySelector('[data-welcome-error]');
          if (success) write(key + '-subscribed', '1');
          on(dialog, 'close', () => {
            write(key + '-closed', Date.now());
            clearTimeout(this.popupTimer);
            this.popupRetry?.abort();
            opener?.focus({ preventScroll: true });
          });
          on(dialog, 'click', event => {
            if (event.target.closest('[data-welcome-close]')) dialog.close();
            if (event.target === dialog) {
              const r = dialog.getBoundingClientRect();
              if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
            }
          });
          on(document, 'click', event => {
            const anchor = event.target.closest('a[href="#astra-welcome"]');
            if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            clearTimeout(this.popupTimer);
            this.popupRetry?.abort();
            if (open(true)) event.preventDefault();
          });
          if (success || error) open(true);
          else if (this.dataset.editor !== 'true' && this.dataset.subscribed !== 'true' && !read(key + '-subscribed')) {
            const hours = Number(this.dataset.hours) || 24;
            const closed = Number(read(key + '-closed')) || 0;
            if (Date.now() - closed >= hours * 3600000) {
              this.popupTimer = setTimeout(() => {
                if (!open(false)) {
                  this.popupRetry = new AbortController();
                  const retry = () => { if (open(false)) this.popupRetry.abort(); };
                  document.addEventListener('visibilitychange', retry, { signal: this.popupRetry.signal });
                  document.addEventListener('pointerup', retry, { signal: this.popupRetry.signal });
                }
              }, (Number(this.dataset.delay) || 40) * 1000);
            }
          }
        }
        const favicon = document.querySelector('link[rel="icon"]');
        this.favicon = favicon;
        this.originalIcon = favicon?.href;
        this.originalIconType = favicon?.type;
        let iconImage;
        const updateIcon = () => {
          if (!favicon || this.dataset.favicon !== 'true') return;
          if (!this.count) { favicon.href = this.originalIcon; favicon.type = this.originalIconType; return; }
          if (!iconImage?.complete || !iconImage.naturalWidth) return;
          const canvas = document.createElement('canvas');
          canvas.width = canvas.height = 64;
          const ctx = canvas.getContext('2d');
          if (!ctx) return;
          ctx.drawImage(iconImage, 0, 0, 64, 64);
          ctx.fillStyle = '#362a25';ctx.beginPath();ctx.arc(44, 43, 20, 0, Math.PI * 2);ctx.fill();
          ctx.font = 'bold 23px sans-serif';ctx.fillStyle = '#fff';ctx.textAlign = 'center';ctx.textBaseline = 'middle';
          ctx.fillText(this.count > 99 ? '99+' : String(this.count), 44, 44);
          try { favicon.href = canvas.toDataURL('image/png'); favicon.type = 'image/png'; } catch {}
        };
        const updateTitle = () => { document.title = document.hidden && this.count > 0 && this.dataset.tabReminder === 'true' ? this.dataset.tabTitle : this.initialTitle; };
        const readCart = () => {
          const cart = document.getElementById('cart-icon-bubble');
          const bubble = cart?.querySelector('.cart-count-bubble [aria-hidden="true"]');
          const match = cart?.textContent.match(/\((\d+)\)/);
          const count = bubble ? Number(bubble.textContent.trim()) : match ? Number(match[1]) : cart?.querySelector('.icon-cart-empty') ? 0 : null;
          if (count !== null && Number.isFinite(count)) this.count = count;
          updateIcon(); updateTitle();
        };
        if (this.dataset.favicon === 'true' && favicon) {
          iconImage = new Image();iconImage.crossOrigin = 'anonymous';
          iconImage.onload = updateIcon;iconImage.src = this.originalIcon;
        }
        const cart = document.getElementById('cart-icon-bubble');
        if (cart) { this.cartObserver = new MutationObserver(readCart); this.cartObserver.observe(cart, { childList: true, subtree: true, characterData: true }); }
        on(document, 'visibilitychange', updateTitle);
        on(window, 'pageshow', readCart);
        readCart();
        if (this.dataset.externalLinks === 'true') {
          on(document, 'click', event => {
            const anchor = event.target.closest('a[href]');
            if (!anchor || anchor.hasAttribute('download') || anchor.target || event.defaultPrevented) return;
            const url = new URL(anchor.href, location.href);
            if (!/^https?:$/.test(url.protocol) || url.origin === location.origin || url.hostname.endsWith('.myshopify.com') || url.hostname === 'shop.app' || url.hostname === 'universbags.com' || url.hostname === 'www.universbags.com') return;
            anchor.target = '_blank';
            anchor.relList.add('noopener');
          });
        }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.popupRetry?.abort();
        this.cartObserver?.disconnect();
        clearTimeout(this.popupTimer);
        if (this.favicon && this.originalIcon) { this.favicon.href = this.originalIcon; this.favicon.type = this.originalIconType; }
        document.title = this.initialTitle;
        this.started = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
